import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMeta from 'vue-meta'
import { trackPageView } from '@ota-frontend/core/helpers/gtm'

import App from './App.vue'
import router from './router'

require('es6-promise').polyfill()
require('isomorphic-fetch')

Vue.config.productionTip = false

Vue.use(VueMeta)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAJA_NQxd2ums14NT9Rg59aNMa8G5n0sCs',
    libraries: 'places',
    region: 'JP',
    language: 'ja',
  },
})
trackPageView(Vue, router)

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
